import { store } from "~/state/store";
import { openPropositionDialog } from "~/util/premium";

// muzu mit poznamku - flag u uzivatele nebo klikatko, musi byt poznamka povolena
export function isPremiumNoteUser() {
	/* eslint-disable */
	const mapyConf = Mapy.CUS.user?.premiumNote;
	const userState = store.getState().user.user?.premium || false;

	return mapyConf || userState;
}


export function openPremiumOnboarding() {
	openPropositionDialog("MyMapsNotes");
}
